import axios from '../axios'

// コース作成（admin のみ）
const postCourseApi = async (payload) => {
  return await axios.post('api/lms/courses', payload)
}

export default postCourseApi
